<template>
  <div class="mt-2 float-right">
    <div @click="$bvModal.show('password-details-modal')" class="link">
      <font-awesome-icon class="font-awesome-icon" icon="pen-square"/>
      {{ title }} wijzigen
    </div>

    <b-modal ref="password-details-modal" id="password-details-modal" footer-class="modal-footer modal-save-details" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-13">
                <label for="password" class="col-form-label">Oude wachtwoord</label>
                <input
                  id="old-password"
                  name="old-password"
                  type="password"
                  class="form-control"
                  :class="{'is-invalid': $v.oldPassword.$error}"
                  v-model="oldPassword"
                  @blur="$v.oldPassword.$touch()"
                >
                <span v-if="$v.oldPassword.$error" class="invalid-feedback" role="alert">
                  <strong>Het oude wachtwoord is verplicht</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-13">
                <label for="password" class="col-form-label">Nieuw wachtwoord</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  class="form-control"
                  :class="{'is-invalid': $v.password.$error}"
                  v-model="password"
                  @blur="$v.password.$touch()"
                >
                <span v-if="$v.password.minLen" class="invalid-feedback" role="alert">
                  <strong>Het wachtwoord moet tenminste {{ $v.password.$params.minLen.min }} karakters bevatten.</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-13">
                <label for="password" class="col-form-label">Bevestig nieuw wachtwoord</label>
                <input
                  id="confirm-password"
                  name="confirm-password"
                  type="password"
                  class="form-control"
                  :class="{'is-invalid': $v.confirmPassword.$error}"
                  v-model="confirmPassword"
                  @blur="$v.confirmPassword.$touch()"
                >
                <span v-if="$v.confirmPassword.$error" class="invalid-feedback" role="alert">
                  <strong>De wachtwoorden komen niet overeen!</strong>
                </span>
              </div>
            </div>
          </form>
        </div>

        <div
          v-if="passwordDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': passwordDetailsStatus.success, 'alert-danger': !passwordDetailsStatus.success }"
        >
          <strong>{{ passwordDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">{{ title }} opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="passwordDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required, sameAs } from 'vuelidate/lib/validators'

  import { MUTATE_PASSWORD_DETAILS_STATUS, SAVE_PASSWORD_DETAILS } from '../../../store/types'

  export default {
    data() {
      return {
        title: 'Wachtwoord',
        oldPassword: '',
        password: '',
        confirmPassword: ''
      }
    },
    validations: {
      oldPassword: {
        required
      },
      password: {
        required,
        minLen: minLength(8)
      },
      confirmPassword: {
        sameAs: sameAs(vm => {
          return vm.password
        })
      }
    },
    computed: {
      passwordDetailsStatus() {
        return this.$store.getters.passwordDetailsStatus
      },
      passwordDetailsBusy() {
        return this.$store.getters.passwordDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['password-details-modal'].hide()
        // discard changes
        this.oldPassword = ''
        this.password = ''
        this.password_confirmation = ''
      },
      saveDetails() {
        const formData = {
          old_password: this.oldPassword,
          password: this.password,
          password_confirmation: this.confirmPassword
        }
        this.$store.dispatch(SAVE_PASSWORD_DETAILS, formData).then(() => {
          if (this.passwordDetailsStatus.success) {
            this.$refs['password-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_PASSWORD_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
